import { Button } from '@ads/components-react';
import { ArrowPathIcon, MagnifyingGlassCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

export interface ClassModuleLoadErrorProps {
  /** Refaz a busca do módulo (ex.: `refetch` da query de detalhe). */
  readonly onRetry: () => void;
}

/**
 * Estado vazio/erro da tela de edição de módulo, exibido quando o módulo não é
 * encontrado ou falha ao carregar. Reproduz o mockup do design: um selo circular
 * com ícone, título, descrição e a ação de tentar novamente.
 *
 * @example
 * ```tsx
 * <ClassModuleLoadError onRetry={() => void refetch()} />
 * ```
 */
export function ClassModuleLoadError({ onRetry }: ClassModuleLoadErrorProps) {
  const { t } = useTranslation('classModuleManagement');

  return (
    <div className="flex flex-col items-center justify-center gap-xs rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface px-md py-xxl text-center shadow-level1">
      <div className="flex flex-col items-center gap-mini">
        <div className="flex items-center justify-center rounded-circular bg-ctx-interactive-secondary p-xxs">
          <MagnifyingGlassCircleIcon className="size-sm text-ctx-content-brand" />
        </div>

        <div className="flex flex-col items-center gap-nano">
          <h2 className="ts-heading-sm text-ctx-content-title">{t('loadError.title')}</h2>
          <p className="ts-paragraph-xs text-ctx-content-base max-w-md">
            {t('loadError.description')}
          </p>
        </div>

        <Button hierarchy="secondary" size="md" leadingIcon={ArrowPathIcon} onClick={onRetry}>
          {t('loadError.retry')}
        </Button>
      </div>
    </div>
  );
}
